export default "__VITE_ASSET__CpQrPvVK__"